module.exports = __webpack_public_path__ + "img/bg.ea6199b2.png";